import enLocale from './en'
import zhLocale from './zh'
Vue.use(VueI18n)

const messages = {
  en: {
    ...enLocale,
    ...ELEMENT.lang.en
  },
  zh: {
    ...zhLocale,
    ...ELEMENT.lang.zhCN
  }
}

const i18n = new VueI18n({
  locale: Cookies.get('language') || 'zh', // set locale
  messages // set locale messages
})

export default i18n



// WEBPACK FOOTER //
// ./src/lang/index.js